import { createSlice } from "@reduxjs/toolkit";


export const wishSlice = createSlice({
    name:'wishlist',
    initialState:{
        whishlistlength:0
    },
    reducers:{
        Wishlengthvalue: (state,action) => {
         state.whishlistlength = action.payload
        }
    }
})

export const { Wishlengthvalue} = wishSlice.actions
export default wishSlice.reducer